module.exports = __webpack_public_path__ + "img/FLOWER HAT RED.0b2575b.svg";